import Lottie from './Lottie';

export default Lottie;
